import type { ColorsType } from './interfaces/colors.type';

export const Colors: ColorsType = {
  primary: '#0084FF',
  primaryLight: '#edf6ff',
  primaryDark: '#0055cb',
  primaryAccent: '#1fc4cc',
  primaryOpacity: '#4dA9FF',

  secondary: '#25CAD3',
  secondaryLight: '#ff983f',
  secondaryDark: '#c43300',
  oeAppSecondary: '#F60',

  background: '#ffffff',
  surface: '#f4f3f4',
  gray: '#444444',
  grayLight: '#eeeeee',
  grayDark: '#444444',
  silverGray: '#666666',
  lightSilverGray: '#999999',
  darkGray: '#d1d1d1',
  error: '#FF0000',
  success: '#33CC00',
  separatorOnBackground: 'rgba(0,0,0,0.1)',
  borderColor: '#dcdcdc',
  offWhite: '#f0f0f0',

  onPrimary: '#ffffff',
  onPrimaryGrayedOut: 'rgba(255,255,255,0.6)',
  onPrimaryOpacity: 'rgb(233,238,255)',
  onSecondary: '#ffffff',
  onSecondaryGrayedOut: 'rgba(255,255,255,0.6)',
  onBackground: '#000000',
  onBackgroundGrayedOut: 'rgba(0,0,0,0.5)',
  onSurface: '#000000',
  onSurfaceGrayedOut: 'rgba(0,0,0,0.5)',
  onError: '#ffffff',
  onSuccess: '#ffffff',

  primaryAquaBlue: '#00dbd1',
  secondaryPacificBlueDark: '#00005c',

  transparent: 'transparent',
  black: '#000000',
};
